import { getApiBasePath } from "@/app/base-path";

export type TransunionFraudCheckParams = {
  emailAddress: string;
  ioBlackBox: string;
  sku: string;
  pathUrl: string;
  tenantId: string;
  phoneNumber?: string;
  sessionId: string;
};

type TransunionFraudCheckResult = {
  result?: string;
  reason?: string;
};

export type TransunionFraudCheckResponse = {
  message?: string;
  localServerResponse?: TransunionFraudCheckResult;
};

export class TransunionApiError extends Error {
  constructor(
    message: string,
    public readonly status: number,
  ) {
    super(message);
    this.name = "TransunionApiError";
  }
}

export async function submitTransunionFraudCheck(
  params: TransunionFraudCheckParams,
): Promise<TransunionFraudCheckResponse> {
  let response: Response;
  try {
    response = await fetch(`${getApiBasePath()}/api/check/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(params),
    });
  } catch (error) {
    // Network failures (offline, DNS, aborted) — never got a response.
    throw new Error("API call failed", { cause: error });
  }

  if (!response.ok) {
    throw new TransunionApiError(`TU proxy returned ${response.status}`, response.status);
  }

  return (await response.json()) as TransunionFraudCheckResponse;
}
